// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.58018 21.7502L20.994 2.33594L22.4082 3.75013L21.1584 5H23V21H5.15873L2.99441 23.1644L1.58018 21.7502Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.4806 5H15.5102L1 19.5105V2.5H9.48063L11.4806 5Z"}}]};

const FolderOffFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-off-filled',
    ref,
    icon: element,
  },
));

FolderOffFilledIcon.displayName = 'FolderOffFilledIcon';

export default FolderOffFilledIcon;
